var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgUploadDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.268,
    height: 47.642,
    viewBox: "0 0 40.268 47.642"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-upload-disabled_svg__cls-2{fill:none;stroke:#e5e2e2;stroke-width:1.6px;stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__ICN_Upload_file_Disabled",
    "data-name": "ICN_Upload file_Disabled",
    transform: "translate(.8 .8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Path_823",
    d: "M8 0h13.557l8 8v22.552a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
    "data-name": "Path 823",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#e5e2e2",
    strokeWidth: 1.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Path_822",
    d: "M0 .6v7.94",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Path 822",
    transform: "translate(20.998 -.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Line_62",
    d: "M0 0h7.999",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Line 62",
    transform: "translate(20.998 8.232)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Group_701",
    "data-name": "Group 701",
    transform: "translate(15.648 23.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Ellipse_163",
    "data-name": "Ellipse 163",
    fill: "#fff",
    stroke: "#e5e2e2",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.91,
    cy: 11.91,
    r: 11.91,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.91,
    cy: 11.91,
    r: 11.11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Group_702",
    "data-name": "Group 702",
    transform: "translate(8.803 6.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Line_78",
    d: "M0 0h6.214",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Line 78",
    transform: "translate(0 9.856)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-upload-disabled_svg__Group_701-2",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Line_79",
    d: "M0 0v6.749",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Line 79",
    transform: "translate(3.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Line_80",
    d: "M3.107 0L0 3.107",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Line 80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-upload-disabled_svg__Line_81",
    d: "M0 0l3.107 3.107",
    className: "kpmg-upload-disabled_svg__cls-2",
    "data-name": "Line 81",
    transform: "translate(3.107)"
  })))))));
}

export default SvgKpmgUploadDisabled;